// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"bbe11539","480":"2261f358","838":"f026e1dd"}[chunkId] + ".js";
};